import './loader.scss';

const Loading = () => <div className="loader" />;

export default Loading;
